import axios from 'axios';
import axiosRetry from 'axios-retry';
import {environment} from '@/environment';
import queryString from "querystring";


const jzAdApiInstance = axios.create({
  baseURL: environment.jzAdApi,
  timeout: 30000
});


let pending = [];
let cancelToken = axios.CancelToken;
let removePending = config => {
  for (let p in pending) {
    if (pending[p].u === config.url + '&' + config.method + '&' + config.data) {
      pending[p].f('duplicate request');
      pending.splice(p, 1);
    }
  }
}

axiosRetry(jzAdApiInstance, {retry: 3});


jzAdApiInstance.interceptors.request
  .use(config => {
    config.withCredentials = true;

    return config;
  });

jzAdApiInstance.interceptors.request.use(config=>{
  removePending(config);
  config.cancelToken = new cancelToken((c)=>{
    pending.push({ u: config.url + '&' + config.method + '&' + config.data, f: c });
  });
  if(config.headers && config.headers['Content-Type']==='application/x-www-form-urlencoded; charset=UTF-8'){
    config.transformRequest = [function(data){
      return queryString.stringify(data)
    }]
  }
  return config;
}, error => {
  return Promise.reject(error)
})

jzAdApiInstance.interceptors.response.use(res => {
  removePending(res.config);
  return res;
}, e => {
  if (e.response && e.response.status == 401 && location.host.indexOf('localhost') == -1) {
    location.href = environment.gwApi+"salary.aspx";
  }
  return Promise.reject(e);
});



export default jzAdApiInstance;
